import React from "react";
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CategoriesHeader } from "./CategoriesHeader";
import { SubCategories } from "./SubCategories";
import { useFetchGet } from "../../hooks";
import { useLocation } from "react-router-dom";

function Categories() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const subCategoryId = queryParams.get('subCategoryId');
    const subCategoryName = queryParams.get('subCategoryName');
    const { categoryId } = useParams();
    const { data, isLoading } = useFetchGet(`https://app-nuokwylgla-uc.a.run.app/api/v1/products/category/${categoryId}`);

    useEffect(() => {
        window.scrollTo(0, 0);
    });
    if (!isLoading) {
        return (
            <React.Fragment>
                <CategoriesHeader
                    data={data.name}
                />
                <SubCategories
                    data={data.subCategories}
                    categoryId={categoryId}
                    subCategoryId={subCategoryId}
                    subCategoryName={subCategoryName} />
            </React.Fragment>
        )
    }
}

export { Categories };